import {preloader} from "./preloader";
import {mainBannerSlider} from "./mainBannerSlider";
import {globalAnimation} from "./globalAnimation";

export function startAnimation() {
    let body = $("body");
    let slider = $(".banner-slider");
    let sliderFunc;

    if (slider.length) {
        sliderFunc = mainBannerSlider();
    }

    if ($(".preloader").length) {
        body.on("preloaderComplete", function () {
            body.removeClass("has-preloader");

            if (slider.length) {
                sliderFunc.sliderPlay();
            }

            globalAnimation().init();
        });

        preloader();

    } else {
        globalAnimation();

        if (slider.length) {
            sliderFunc.sliderPlay();
        }
    }
}



// WEBPACK FOOTER //
// ./assets/js/modules/startAnimation.js